import gsap from 'gsap';

$(".logo-wall:not(.-full) .open-more").on("click", function () {
    const thisWall = $(this).closest(".logo-wall").find(".logos");
    const windowWidth = $(window).width();
    const wallHeight = calculateWallHeight(windowWidth);

    $(this).toggleClass("-open");
    thisWall.toggleClass("-open");

    if ($(this).hasClass("-open")) {
        expandGallery(thisWall[0]);
    } else {
        closeGallery(thisWall[0], wallHeight);
        scrollToSection(thisWall.closest('section.logo-wall')); // Scroll to section top
    }
});
function scrollToSection(section) {
    $('html, body').animate({
        scrollTop: $(section).offset().top
    }, 1000);
}
function calculateWallHeight(windowWidth) {
    if (windowWidth < 1440 && windowWidth >= 768) {
        return 360;
    } else if (windowWidth < 768) {
        return 512;
    }
    return 384;
}

function expandGallery(this_wall) {
    gsap.timeline()
        .to(this_wall, {
            duration: 1,
            delay: 0.1,
            height: "auto",
            ease: "power4.out"
        })

}

function closeGallery(this_wall, height) {
    gsap.timeline()
        .to(this_wall, {
            delay: 0.1,
            duration: 1,
            ease: "power4.out",
            height: height,
        })
}
